import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import './Login.css'

export function Login() {
    const { login } = useAuth()
    const navigate = useNavigate()
    const [cpf, setCpf] = useState('')
    const [password, setPassword] = useState('')
    const [twoFactorCode, setTwoFactorCode] = useState('')
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const [showTwoFactorModal, setShowTwoFactorModal] = useState(false)
    const [codeSentMessage, setCodeSentMessage] = useState('')
    const [verifying, setVerifying] = useState(false)
    const [twoFactorError, setTwoFactorError] = useState('')

    async function handleLogin() {
        if (!cpf || !password) {
            setError('Preencha todos os campos')
            return
        }
        setLoading(true)
        setError('')
        try {
            const result = await login(cpf, password)

            // if (result?.requiresTwoFactor) {
            //     setCodeSentMessage(
            //         result.codeSent
            //             ? 'Enviamos um código de verificação para o seu email. Certifique de que seu E-mail seja Valido. Verifique a caixa de SPAM! Caso não receba o E-mail entre em contato com o suporte.'
            //             : 'Informe o código de verificação enviado anteriormente.'
            //     )
            //     setShowTwoFactorModal(true)
            //     return
            // }

            navigate('/catalogo')
        } catch {
            setError('Matrícula ou senha incorretos')
            setTimeout(() => setError(''), 10000)
        } finally {
            setLoading(false)
        }
    }

    async function handleVerifyCode() {
        if (!twoFactorCode) {
            setTwoFactorError('Digite o código recebido')
            return
        }
        setVerifying(true)
        setTwoFactorError('')
        try {
            await login(cpf, password, twoFactorCode)
            navigate('/catalogo')
        } catch {
            setTwoFactorError('Código inválido ou expirado')
        } finally {
            setVerifying(false)
        }
    }

    function handleTwoFactorKeyDown(e: React.KeyboardEvent) {
        if (e.key === 'Enter') handleVerifyCode()
    }

    function handleKeyDown(e: React.KeyboardEvent) {
        if (e.key === 'Enter') handleLogin()
    }

    return (
        <div className="login-wrap">
            <div className="login-art">
                <div className="login-art-content">
                    <div className="kicker">S.I.M. | Sistema de Informação de Marketing</div>
                    <h1>O conhecimento <em>que move</em> a rede.</h1>
                    <p>Aprendizado contínuo para transformar informação em ação e resultados.</p>
                </div>
                <div className="login-art-footer">Gazin · 1966–2066</div>
            </div>

            <div className="login-form-wrap">
                <div className="login-form">
                    <div className="brand-mark-lg">S</div>
                    <h2>S.I.M. Academy</h2>
                    <p className="sub">Entre com sua matrícula para continuar.</p>

                    {error && <div className="login-error">{error}</div>}

                    <div className="field">
                        <label>Matrícula (CPF)</label>
                        <input
                            type="text"
                            value={cpf}
                            onChange={e => setCpf(e.target.value)}
                            onKeyDown={handleKeyDown}
                            placeholder="000.000.000-00"
                            autoFocus
                        />
                    </div>
                    <div className="field">
                        <label>Senha</label>
                        <input
                            type="password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            onKeyDown={handleKeyDown}
                            placeholder="Sua senha"
                        />
                    </div>

                    <button
                        className="btn btn-primary btn-full"
                        onClick={handleLogin}
                        disabled={loading}
                    >
                        {loading ? 'Entrando...' : 'Entrar'}
                    </button>

                    {/* <div className="login-help">
                        <span>Primeiro acesso ou esqueceu a senha?</span>
                        <a onClick={() => alert('Senha provisória enviada por WhatsApp para o telefone cadastrado.')}>
                            Recuperar via WhatsApp
                        </a>
                    </div> */}
                </div>
            </div>
            {showTwoFactorModal && (
                <div className="modal-overlay">
                    <div className="modal-box">
                        <h3>Verificação de segurança</h3>
                        <p className="sub">{codeSentMessage}</p>

                        {twoFactorError && <div className="login-error">{twoFactorError}</div>}

                        <div className="field">
                            <label>Código de verificação</label>
                            <input
                                type="text"
                                value={twoFactorCode}
                                onChange={e => setTwoFactorCode(e.target.value)}
                                onKeyDown={handleTwoFactorKeyDown}
                                placeholder="000000"
                                maxLength={6}
                                autoFocus
                            />
                        </div>

                        <button
                            className="btn btn-primary btn-full"
                            onClick={handleVerifyCode}
                            disabled={verifying}
                        >
                            {verifying ? 'Verificando...' : 'Confirmar'}
                        </button>

                        <button
                            className="btn btn-link"
                            onClick={() => {
                                setShowTwoFactorModal(false)
                                setTwoFactorCode('')
                                setTwoFactorError('')
                            }}
                        >
                            Voltar
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}